<template>
    <div>
        <div style="display: flex; gap: 10px; margin-bottom: 40px;">
            <div style="width: 250px;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Fabricante') }}</div>
                <Dropdown v-model="form['manufacturer_id']" :options="optionsManufacturers" :filter="true" :dataKey="'id'"
                    style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="name" optionValue="id"
                    :class="{'p-invalid': $v.form.manufacturer_id.$error && $v.form.manufacturer_id.$dirty}" />
            </div>
            <div style="width: 250px;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Modelo') }}</div>
                <Dropdown v-model="form['vehicles_manufacturer_models_id']" :options="optionsVehicles" :filter="true"
                    style="width: 100%; height: 40px; max-width: 276px;" optionLabel="name" optionValue="id"
                    @change="getAlgorithmByVehicleModel($event.value)" :disabled="!this.form.manufacturer_id" :dataKey="'id'"
                    :class="{'p-invalid': $v.form.vehicles_manufacturer_models_id.$error && $v.form.vehicles_manufacturer_models_id.$dirty}" />
            </div>
            <app-button type="secondary"
                        class="auto-center"
                        style="background-color: #0D89EC; position: relative; top: 8px;"
                        @handleClick="exportCsv"
                        :disabled="gridData.length === 0">
                <i class="pi pi-external-link" />
                {{$t('AppAlertsCoaAlertsConfig.Exportar')}}
            </app-button>
        </div>

        <DataTable :value="gridData" :paginator="true" :rows="6" :rowHover="true" :loading="loading" :selection.sync="selectedAlgorithm"
                filterDisplay="row" :filters.sync="filters" :sortOrder="1" stripedRows
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                responsiveLayout="scroll"
                :currentPageReportTemplate="$t('AppAlertsCoaAlertsConfig.Mostrando {first} até {last} de {totalRecords} Alertas')"
                class="p-datatable-striped">
            <Column headerClass="headerClass" bodyClass="bodyClass" selectionMode="multiple" :styles="{'max-width': '1em'}"></Column>
            <Column field="code_alert" :header="$t('AppAlertsCoaAlertsConfigForm.Código do Alerta')" headerClass="headerClass" bodyClass="bodyClass"
                    :showFilterMenu="false" :showClearButton="false" :styles="{'max-width': '3rem'}">
                <template #body="slotProps">
                    <span>{{ slotProps.data.code_alert }}</span>
                </template>
                <template #filter="{filterModel,filterCallback}">
                    <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                </template>
            </Column>
            <Column field="criticality_level" :header="$t('AppAlertsCoaAlertsConfigForm.Criticidade')" headerClass="headerClass" bodyClass="bodyClass"
                    :showFilterMenu="false" :showClearButton="false" :styles="{'max-width': '3rem'}">
                <template #body="slotProps">
                    <span :class="'badge criticalityLevel-' + slotProps.data.criticality_level">
                        {{ getCriticalityLevel(slotProps.data.criticality_level) }}
                    </span>
                </template>
                <template #filter="{filterModel,filterCallback}">
                    <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsCriticalityLevel"
                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="code" optionValue="code">
                        <template #value="slotProps">
                            <span v-for="singleValue in slotProps.value" :class="'badge criticalityLevel-' + singleValue" style="margin-right: 5px;">
                                {{ getCriticalityLevel(singleValue) }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <span :class="'badge criticalityLevel-' + slotProps.option.code">
                                {{ getCriticalityLevel(slotProps.option.code) }}
                            </span>
                        </template>
                    </MultiSelect>
                </template>
            </Column>
            <Column field="description" :header="$t('AppAlertsCoaAlertsConfigForm.Descrição')" headerClass="headerClass" bodyClass="bodyClass"
                    :showFilterMenu="false" :showClearButton="false" :styles="{'max-width': '3rem'}">
                <template #body="slotProps">
                    <div v-if="slotProps.data.description != null && slotProps.data.description.length > 23" v-tooltip.top="`${slotProps.data.description}`">
                        {{ slotProps.data.description.slice(0, 23) + ' ...' }}
                    </div>
                    <div v-else>
                        {{ slotProps.data.description }}
                    </div>
                </template>
                <template #filter="{filterModel,filterCallback}">
                    <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                </template>
            </Column>
        </DataTable>

        <div style="float: right;">
            <Button :label="$t('AppAlertsCoaAlertsConfig.Cancelar')" icon="pi pi-times" class="p-button-text p-button-danger" @click="$emit('closeDialog')"/>
            <Button :label="$t('AppAlertsCoaAlertsConfig.Confirmar')" icon="pi pi-check" class="p-button-text" @click="validate" />
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button/Button';
import Dialog from 'primevue/dialog/Dialog';
import InputText from 'primevue/inputtext/InputText';
import InputNumber from 'primevue/inputnumber';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import SelectButton from 'primevue/selectbutton';
import {CRITICALY_LEVELS, STATUSES_ALERT} from '../AppOptionsCoa';
import {required} from 'vuelidate/lib/validators';
import VehiclesManufacturersService from '../../../../services/VehiclesManufacturersService';
import AlertsCoaService from '../../../../services/AlertsCoaService';
import Tooltip from 'primevue/tooltip';
import {FilterMatchMode} from 'primevue/api';
import AppButton from '../../../common/AppButton.vue';
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import displayToast from '@/mixins/ToastMixin';

export default {
    mixins: [exportJsonToCsv, displayToast],
    props: {
        optionsManufacturers: {
            type: Array,
        },
    },
    data() {
        return {
            form: {},
            optionsCriticalityLevel: CRITICALY_LEVELS,
            isNewForm: false,
            optionsVehicles: [],
            gridData: [],
            selectedAlgorithm: [],
            filters: {
                'code_alert': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'criticality_level': {value: null, matchMode: FilterMatchMode.IN},
                'description': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            loading: false,
            orgId: null
        }
    },
    created() {
        this.vehiclesManufacturersService = new VehiclesManufacturersService();
        this.alertsCoaService = new AlertsCoaService();
    },
    methods: {
        cleanForm(orgId){
            this.orgId = orgId
            this.isNewForm = true
            this.form = {}
        },
        editForm(orgId, val){
            this.orgId = orgId
            this.isNewForm = false
            this.form = {}
            this.form = { ...val }
            this.getAlgorithmByVehicleModel(val.vehicles_manufacturer_models_id);
        },
        getAlgorithmByVehicleModel(val){
            this.alertsCoaService.getAlgorithmByVehicleModel(this.orgId, val)
                .then((data) => {
                    this.selectedAlgorithm = data.filter(item => item.status === 'ENABLED');
                    this.gridData = data;
                })
                .catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Não foi possível buscar os modelos'), 'e', error)
                });
        },
        validate(){
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                this.saveAlgorithmAlert();
            } else {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Por favor preencha todos os campos obrigatórios'), 'e')
            }
        },
        saveAlgorithmAlert() {
            let formToSend = JSON.parse(JSON.stringify(this.gridData)).map(item => ({
                id: item.id,
                status: this.selectedAlgorithm.find(selected => selected.id === item.id) ? STATUSES_ALERT[0].code : STATUSES_ALERT[1].code
            }));

            this.alertsCoaService.editAlgorithmAlerts(this.orgId, formToSend).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Editado com sucesso'), 's')
                    this.$emit('reloadFailures');
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível criar o alerta'), 'e', error)
                })
        },
        exportCsv(){
            let csvData = [];
            JSON.parse(JSON.stringify(this.gridData)).forEach(data => {
                data.criticality_level = this.getCriticalityLevel(data.criticality_level)
                csvData.push(data)
            });

            const CSV_FIELDS = ['code_alert', 'criticality_level', 'description']
            const CSV_LABELS = ['Código do Alerta', 'Criticidade', 'Descrição']
            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, "alertas-de-maquina");
        },
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
    },
    watch: {
        'form.manufacturer_id': function (val) {
            this.vehiclesManufacturersService.findAllModelsByManufacturerId(val)
                .then((data) => {
                    let newData = []
                    data.models.forEach(model => {
                        newData.push({
                            id: model.id,
                            name: model.name,
                        })
                    });
                    this.optionsVehicles = newData;
                })
                .catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Não foi possível buscar os modelos'), 'e', error)
                });
        }
    },
    validations: {
        form: {
            vehicles_manufacturer_models_id: {required},
            manufacturer_id: {required}
        }
    },
    components: {
        Dialog, 
        Button, 
        InputText, 
        Dropdown, 
        InputNumber, 
        SelectButton,
        DataTable,
        Column,
        Tooltip,
        MultiSelect,
        AppButton
    },
    directives: {
        tooltip: Tooltip
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";
</style>